import React, { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import TreatCard from "./TreatCard";
const treatList = [
  {
    id: "1",
    title: "Efficient Drug Delivery",
    text: "Over 10 times more effective absorption compared to conventional methods like micro-needling.",
    addClass: "topl2",
  },
  {
    id: "2",
    title: "Ultrasonic Enhancement",
    text: "Utilizes ultrasonic waves to stimulate the scalp, enhancing blood flow and follicle health.",
    addClass: "topr2 right",
  },
  {
    id: "3",
    title: "Pain-Free Experience",
    text: "Offers a non-invasive, comfortable treatment alternative to traditional methods, significantly improving patient satisfaction.",
    addClass: "midl2",
  },
  {
    id: "4",
    title: "Stimulated Blood Flow",
    text: "Enhanced circulation to the hair follicles, promoting health and growth.",
    addClass: "midr2 right",
  },
  {
    id: "5",
    title: "Comfort and Safety",
    text: "A painless procedure that's safe for all skin types, ensuring a pleasant and stress-free experience for patients.",
    addClass: "botl2",
  },
  {
    id: "6",
    title: "Enhanced Absorption",
    text: "The formulation promotes optimal absorption, significantly improving the efficacy of the treatment.",
    addClass: "botr2 right",
  },
];
export default function Treat2() {
  const [modal, setModal] = useState(false);
  const [modalData, setModalData] = useState(null);
  const [mobile, setMobile] = useState(false);
  useEffect(() => {
    if (window.innerWidth < 750) {
      setMobile(true);
    } else {
      setMobile(false);
    }
    window.addEventListener("resize", () => {
      if (window.innerWidth < 750) {
        setMobile(true);
      } else {
        setMobile(false);
      }
    });
  }, []);
  useEffect(() => {
    if (modal) {
      document.body.classList.add("active");
    } else {
      document.body.classList.remove("active");
    }
  }, [modal]);
  const closeFunc = (e) => {
    if (e.currentTarget === e.target) setModal(null);
  };
  return (
    <>
      <section className="treat" aria-labelledby="soundhair-heading">
        <div className="auto__container">
          <div className="treat__inner">
            <div className="treat__inner-row">
              <div className="treat__inner-image" aria-hidden="true">
                <img className="desc" src="/images/treat/shape-2.png" alt="SOUNDHAIR technology illustration - desktop view" />
                <img className="mob" src="/images/treat/circle-2.png" alt="SOUNDHAIR technology illustration - mobile view" />
              </div>
              <div className="treat__inner-content">
                <h3 id="soundhair-heading">SOUNDHAIR Technology</h3>
                <p>
                  SOUNDHAIR is a breakthrough in hair restoration. Our
                  technology integrates ultrasonic waves with our advanced
                  topical treatments, setting new benchmarks in effectiveness
                  and patient comfort.
                </p>
              </div>
            </div>
            <div className="treatMain">
              <div className="treatMain__title">
                <hr />
                <h3 id="sound-features-heading">Key Features</h3>
                <hr />
              </div>
              <div className="treatMain__content">
                <div className="treatMain__image">
                  <img src="/images/treat/2.png" alt="Visual representation of SOUNDHAIR technology key features" />
                </div>
                <div className="treatMain__list" role="list">
                  {treatList.map((item, index) => {
                    return (
                      <TreatItem
                        mobile={mobile}
                        onClick={() => {
                          setModal(true);
                          setModalData(item);
                        }}
                        {...item}
                        key={index}
                      />
                    );
                  })}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <AnimatePresence>
        {modal && (
          <TreatCard
            closeFunc={closeFunc}
            setModal={setModal}
            modalData={modalData}
          />
        )}
      </AnimatePresence>
    </>
  );
}
const TreatItem = (props) => {
  const [active, setActive] = useState(false);
  return (
    <div
      className={"treatItem " + (props.addClass ? props.addClass : "")}
      role="listitem"
    >
      <div
        className="treatItem__title"
        onClick={() => {
          if (props.mobile) {
            props.onClick();
          } else {
            setActive(!active);
          }
        }}
        role="button"
        aria-expanded={active}
        aria-controls={`treat2-item-${props.id}-content`}
        tabIndex="0"
        onKeyDown={(e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            if (props.mobile) {
              props.onClick();
            } else {
              setActive(!active);
            }
            e.preventDefault();
          }
        }}
      >
        <h4 id={`treat2-item-${props.id}-title`}>{props.title}</h4>
        <span aria-hidden="true"></span>
      </div>
      <AnimatePresence>
        {active && (
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.2 }}
            exit={{ opacity: 0 }}
            className="treatItem__body"
            id={`treat2-item-${props.id}-content`}
            aria-labelledby={`treat2-item-${props.id}-title`}
          >
            <p className="sm">{props.text}</p>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
};
